import { Form, useForm } from "@/components/form";
import { useFiltersReturn } from "../hooks/use-filters";
import { Stack } from "@mui/material";

export default function FilterForm({
    filterData
}: {
    filterData: useFiltersReturn
}) {
    const form = useForm({
        defaultValues: filterData.filterData as any,
        onSubmit: ({ value, meta }) => {
            if (meta === "reset") {
                const keepData = filterData.filters.reduce((prev, filter) => {
                    if (filter.type === "pagination") {
                        prev[filter.pageName] = 0;
                        prev[filter.pageSizeName] = filter.pageSize;
                    }
                    return prev;
                }, {} as Record<string, any>)
                filterData.setFilterData(keepData);
            } else {
                filterData.setFilterData(value)
            }
        },
        submitOnce: false,
        closeModalOnSubmit: false
    })

    const renderFilters = () => {
        return filterData.filters
            .filter(filter => filter.type !== "pagination")
            .map(filter => {
                switch (filter.type) {
                    case "string": return <Form.TextField key={filter.key} name={filter.name} label={filter.label} />
                    case "select": return <Form.Select key={filter.key} name={filter.name} label={filter.label}>
                        {filter.options.map(o => <Form.Select.Option key={String(o.value)} value={o.value}>{o.label}</Form.Select.Option>)}
                    </Form.Select>
                    case "dateRange": return <Stack key={filter.key} direction={"row"} gap={2} flexWrap={"wrap"}>
                        <Stack flex="1 1 150px">
                            <Form.DatePicker name={filter.fromName} label={filter.fromLabel} clearable />
                        </Stack>
                        <Stack flex="1 1 150px">
                            <Form.DatePicker name={filter.toName} label={filter.toLabel} displayDateOffset={-1} clearable />
                        </Stack>
                    </Stack>
                    case "model": return <Form.ModelComboBox key={filter.key} name={filter.name} label={filter.label}
                        get={filter.get} getAll={filter.getAll} labelName={filter.labelName} renderOption={filter.renderOption} />
                    default: return undefined;
                }
            })
    }

    return <Form form={form} gap={3} padding={3}>
        {renderFilters()}
        <Stack gap={2} direction={"row"}>
            <Stack flex={1}>
                <Form.SubmitButton variant="outlined" name="reset">Borrar</Form.SubmitButton>
            </Stack>
            <Stack flex={1}>
                <Form.SubmitButton>Filtrar</Form.SubmitButton>
            </Stack>
        </Stack>
    </Form>
}